import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormNavigation } from '@fmnts/api/next';
import { I18nModule } from '@fmnts/i18n';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'next-form-actions',
  templateUrl: './form-actions.component.html',
  imports: [I18nModule],
})
export class FormActionsComponent {
  @Input() actions: FormNavigation[] = [];

  /** Array of actions that are disabled */
  @Input() disabled: string[] = [];

  @Output() action = new EventEmitter<string>();

  isDisabled({ action }: FormNavigation): boolean {
    return this.disabled.includes(action);
  }

  handleAction(action: string): void {
    this.action.emit(action);
  }
}
